import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "api";
import { setSessionState } from "./sessionSlice";

export const fetchSession = createAsyncThunk(
  "session/fetchSession",
  async (_, { dispatch, rejectWithValue }) => {
    return api.session
      .sessionCheck()
      .then(() => {
        dispatch(setSessionState("valid"));
      })
      .catch(async (res) => {
        dispatch(setSessionState("invalid"));
        return rejectWithValue(res.error);
      });
  },
);
